module.exports = __webpack_public_path__ + "media/3_6-5.f60c854d.mp3";